import MultiForm from '@admin/components/multiform'
import PropTypes from 'prop-types'
import Choose from './choose'
import Details from './details'
import Type from './type'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    contact_ids: PropTypes.array,
    event: PropTypes.object,
    filter: PropTypes.object,
    form: PropTypes.object,
    list: PropTypes.object,
    program: PropTypes.object,
    program_id: PropTypes.number,
    webinar: PropTypes.object,
    service: PropTypes.object,
    strategy: PropTypes.string,
    store: PropTypes.object,
    user: PropTypes.object,
    onBack: PropTypes.func
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <MultiForm { ...this._getMultiForm() } />
  }

  _getMultiForm() {
    const { strategy } = this.props
    const program = this._getProgram()
    const program_id = this.props.program_id || program.id
    return {
      title: 't(New Email Campaign)',
      action: '/api/admin/campaigns/email',
      method: 'POST',
      defaultValue: strategy ? { strategy } : {},
      formatData: this._getData.bind(this),
      getSteps: this._getSteps.bind(this),
      props: {
        program,
        program_id
      },
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess
    }
  }

  _getData(email_campaign) {
    const { contact_ids, filter, form, list, program_id, service, webinar } = this.props
    return {
      ...form ? {
        form_id: form.id,
        to: { send_strategy: 'responses' }
      } : service ? {
        service_id: service.id,
        to: { send_strategy: 'subscriptions' }      
      } : webinar ? {
        webinar_id: webinar.id,
        to: { send_strategy: 'participants' }
      } : list ? {
        to: { send_strategy: 'list', send_config: { list_id: list.id } }
      } : filter ? {
        to: { send_strategy: 'filter', send_config: { filter_id: filter.id } }
      } : contact_ids ? {
        to: { send_strategy: 'contacts', send_config: { contact_ids } }
      } : {},
      program_id,
      strategy: email_campaign.strategy,
      ...email_campaign.strategy !== 'scratch' ? {
        truevail_template_id: email_campaign.truevail_template.id
      } : {},
      title: email_campaign.title,
      purpose: email_campaign.purpose,
      subject: email_campaign.subject,
      preview_text: email_campaign.preview_text,
      template_id: email_campaign.template_id,
      sender_id: email_campaign.sender_id
    }
  }

  _getProgram() {
    const { event, form, list, program, service } = this.props
    const { admin} = this.context
    if(event) return event.program
    if(form) return form.program
    if(list) return list.program
    if(program) return program
    if(service) return service.program
    return admin.team.program
  }

  _getSteps(formdata) {
    const { strategy } = this.props
    return [
      ...!strategy ? [
        { label: 't(Type)', component: Type }
      ] : [],
      ...formdata.strategy !== 'scratch' ? [
        { label: 't(Choose)', component: Choose }
      ] : [],
      { label: 't(Details)', component: Details }
    ]
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(email_campaign) {
    this.context.router.push(`/campaigns/email/${email_campaign.id}`)
    this.context.modal.close()
  }

}

export default New